import React, {useContext} from 'react';
import '../view-archer-styles.css';

// material-ui: theme, colors, icons
import { Alert,Card, CardContent, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material/';
import { blue, red } from '@mui/material/colors';

//components import
import FilerResponse from '../dataObjects/FilerResponse';
import { AuditorCommunicationContext } from '../view-archer';

interface Props {
    pendingResponses?: FilerResponse[];
}

const DashboardPendingResponses = (props: Props) => {

    //initial state setup
    const context = useContext(AuditorCommunicationContext);

    const setCurrentLetterCpfId = (cpfId: number) => {
        context.setCurrentLetterCpfId(cpfId);
    }

    return (
        <div>
            <Card className="dashboard-tile">
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container alignContent="center" justifyContent="space-between">
                                <Grid item>
                                    <Typography variant="subtitle1" color="blue">Pending Responses {props.pendingResponses && `(${props.pendingResponses.length})`}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            {
                                props.pendingResponses && props.pendingResponses.length === 0 &&
                                <Alert severity="success" sx={{ margin: 2 }}>There are no pending responses!</Alert>
                            }
                            {
                                props.pendingResponses && props.pendingResponses.length > 0 &&
                                <TableContainer sx={{ maxHeight: 265, m: 1 }}>
                                    <Table stickyHeader size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Filer</TableCell>
                                                <TableCell sx={{ textAlign: "left!important" }}>Issue</TableCell>
                                                <TableCell>Resp. #</TableCell>
                                                <TableCell>Resp.Date</TableCell>
                                                <TableCell>Resp.Type</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                props.pendingResponses?.map((response,index) =>
                                                    <TableRow
                                                        key={index}
                                                    >
                                                        <TableCell className="is-clickable" onClick={() => setCurrentLetterCpfId(response.cpfId)}><strong>{response.cpfId} {response.filerFullName}</strong></TableCell>
                                                        <TableCell>
                                                            <Typography variant="body2" sx={{ color: red[500] }} className="is-clickable issue-link-text" onClick={() => setCurrentLetterCpfId(response.cpfId)}>{response.issueTypeCode} {response.header} <Typography variant="body2" sx={{ color: blue[500] }}>(<i>sent {response.issueDate}</i>)</Typography></Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant="body2" className="issue-link-text"><i>{response.responseCount}</i></Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant="body2" className="issue-link-text"><i>{response.responseDate}</i></Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant="body2" sx={{ color: blue[500] }}>{response.responseTypeDescription}</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            }
                            
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>     
   )
}

export default DashboardPendingResponses;